<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import * as PDFObject from 'pdfobject';
import { uniqueID } from '@integro/core';
import { isString } from 'lodash';

const props = defineProps<{
  b64?: string;
  file?: File;
}>();

const id = ref(uniqueID());

function getEmbedOptions() {
  return {
    forceIframe: true,
  };
}

function getBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function displayPDF() {
  if (props.b64) {
    PDFObject.embed(props.b64, `#${id.value}`, getEmbedOptions());
  } else if (props.file) {
    getBase64(props.file).then((result) => {
      if (isString(result)) {
        PDFObject.embed(result, `#${id.value}`, getEmbedOptions());
      }
    });
  }
}

watch(
  () => props.b64,
  () => {
    displayPDF();
  },
);

watch(
  () => props.file,
  () => {
    displayPDF();
  },
);

onMounted(() => {
  displayPDF();
});
</script>

<template>
  <div :id="id">&nbsp;</div>
</template>
